export const SITE_ORIGIN = 'https://pick-pro.com';
